import template from './pepperResolveAuth.template.html';

export default {
  bindings: {
    onFinish: '&',
    lenders: '<'
  },
  controller: class controller {
    constructor($mdDialog) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;

      this.initialize = () => {
        $mdDialog
          .show({
            locals: {},
            template,
            controllerAs: '$ctrl',
            multiple: true,
            controller() {
              this.existingPepperAccreditation = _.find(
                ctrl.lenders,
                (lender) => lender.idLender === '49ccfd3517f32c5f167c0231133b5c2e'
              );
              this.brokerId =
                (this.existingPepperAccreditation &&
                  this.existingPepperAccreditation.brokerIdPrimary) ||
                '';
              this.confirm = () => {
                $mdDialog.hide({ brokerId: this.brokerId });
              };
              this.cancel = () => {
                $mdDialog.hide(null);
              };
            },
            clickOutsideToClose: false
          })
          .then((res) => {
            ctrl.onFinish({ status: res });
          });
      };

      this.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
